import {InitialRequestUrl} from "@repo/shared-core";
import {parseUrl} from "@repo/urls";

import {isAPIURL} from "./is-api-url.ts";

/**
 * Send XSRF token in the request via header so it can be matched up w/
 * cookie value.
 *
 * @param url the URL of the request
 * @returns an array of name/value pairs to set as headers by the user of
 * this function.
 */
export const getXsrfKeyHeaders = (
    url: string,
): Array<{
    name: string;
    value: string;
}> => {
    // Any time we are not same-origin it is fine to skip the header.
    // The only time we do that is if we are going to cdn, or a third-party
    // domain, in which case we should never be doing something that needs
    // csrf checks (and it's arguably in fact safer to omit it so there's
    // less opportunity for compromise of your xsrf key)
    // At least in some cases it's also necessary to avoid the CORS
    // preflight check
    const urlOrigin = parseUrl(url).origin;

    if (!isAPIURL(url) || InitialRequestUrl.origin !== urlOrigin) {
        return [];
    }

    return [{name: "X-KA-FKey", value: "1"}];
};
